import script from "./product.vue?vue&type=script&lang=ts&setup=true"
export * from "./product.vue?vue&type=script&lang=ts&setup=true"

import "./product.vue?vue&type=style&index=0&id=bc1f5658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc1f5658"]])

export default __exports__